// Deterministic 32-bit FNV-1a hash of `${seed}:${id}` mapped to [0, 1).
//
// Pure: a given (seed, id) always yields the same value. Three unrelated callers
// depend on that property for different reasons — the recommender keeps a seeded
// feed ordering reproducible across paginated requests (`domain/personal-feed.ts`),
// cover-art generation keeps a playlist's anchor colour stable across
// regenerations (`domain/cover-art.ts`), and the webapp draws the same backdrop
// for a collection with no image on every device (`DesktopPlaylistPage.tsx`). It
// lives here, in the isomorphic `shared/`, because none of them owns the concept,
// and duplicating it would let one caller's tweak silently move another's output.
//
// NOT cryptographic and never to be used as one: FNV-1a is chosen for being
// cheap, stable across processes, and dependency-free.
export function seededUnit(seed: string, id: string): number {
  const input = `${seed}:${id}`;
  let hash = 2166136261;
  for (const char of input.split("")) {
    const codePoint = char.codePointAt(0);
    if (codePoint === undefined)
      throw new Error("should not happen: hash character has no code point");
    hash ^= codePoint;
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) / 4294967296;
}
